import GetProductThumbnailRequestModelBase from '../_generated/modelBases/get-product-thumbnail-request-model-base';

export default class GetProductThumbnailRequestModel extends GetProductThumbnailRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
